
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { ElementWrapper } from '@cloudscape-design/test-utils-core/dom';
import { appendSelector } from '@cloudscape-design/test-utils-core/utils';

export { ElementWrapper };

import CodeViewWrapper from './code-view';


export { CodeViewWrapper };

declare module '@cloudscape-design/test-utils-core/dist/dom' {
   interface ElementWrapper {
    
/**
 * Returns the wrapper of the first CodeView that matches the specified CSS selector.
 * If no CSS selector is specified, returns the wrapper of the first CodeView.
 * If no matching CodeView is found, returns `null`.
 *
 * @param {string} [selector] CSS Selector
 * @returns {CodeViewWrapper | null}
 */
findCodeView(selector?: string): CodeViewWrapper | null;

/**
 * Returns an array of CodeView wrapper that matches the specified CSS selector.
 * If no CSS selector is specified, returns all of the CodeViews inside the current wrapper.
 * If no matching CodeView is found, returns an empty array.
 *
 * @param {string} [selector] CSS Selector
 * @returns {Array<CodeViewWrapper>}
 */
findAllCodeViews(selector?: string): Array<CodeViewWrapper>;

/**
 * Returns the wrapper of the closest parent CodeView for the current element,
 * or the element itself if it is an instance of CodeView.
 * If no CodeView is found, returns `null`.
 *
 * @returns {CodeViewWrapper | null}
 */
findClosestCodeView(): CodeViewWrapper | null;
   }
}


ElementWrapper.prototype.findCodeView = function(selector) {
  let rootSelector = `.${CodeViewWrapper.rootSelector}`;
  if("legacyRootSelector" in CodeViewWrapper && CodeViewWrapper.legacyRootSelector){
    rootSelector = `:is(.${CodeViewWrapper.rootSelector}, .${CodeViewWrapper.legacyRootSelector})`;
  }
  // casting to 'any' is needed to avoid this issue with generics
  // https://github.com/microsoft/TypeScript/issues/29132
  return (this as any).findComponent(selector ? appendSelector(selector, rootSelector) : rootSelector, CodeViewWrapper);
};

ElementWrapper.prototype.findAllCodeViews = function(selector) {
  return this.findAllComponents(CodeViewWrapper, selector);
};

ElementWrapper.prototype.findClosestCodeView = function() {
  // casting to 'any' is needed to avoid this issue with generics
  // https://github.com/microsoft/TypeScript/issues/29132
  return (this as any).findClosestComponent(CodeViewWrapper);
};

export default function wrapper(root: Element = document.body) {
  if (document && document.body && !document.body.contains(root)) {
    console.warn('[AwsUi] [test-utils] provided element is not part of the document body, interactions may work incorrectly')
  };
  return new ElementWrapper(root);
}
